import { Center, VStack, Icon, Heading } from '@chakra-ui/react'
import type { ReactElement } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import EmptyMediaCollectionGraphic from '../../../../graphics/media-library/EmptyMediaCollectionGraphic'

const EmptyMediaCollectionView = ({minHeight}: {minHeight?: string}): ReactElement => {
  const { t } = useTranslation()

  return (
    <Center height="100%" width="100%" minHeight={minHeight}>
      <VStack spacing={8}>
        <Icon
          as={EmptyMediaCollectionGraphic}
          width="260px"
          height="200px"
          color="appClearBlue"
        />
        <VStack spacing={2} width="100%">
          <Trans t={t} i18nKey="empty_media_collection">
            <Heading as="h4" fontSize="md" color="appBattleshipGrey">
              Media Collection is empty
            </Heading>
            <Heading
              as="h6"
              fontSize="1em"
              fontWeight="semibold"
              color="appBattleshipGrey"
            >
              To add assets, browse or search the Media Library.
            </Heading>
            {/* <Heading
              as="h6"
              fontSize="1em"
              fontWeight="semibold"
              color="appBattleshipGrey"
            >
              Then select multiple assets and choose 'Manage media collection'
              and check on the media collection you wish to add assets to.
            </Heading> */}
          </Trans>
        </VStack>
      </VStack>
    </Center>
  )
}

export default EmptyMediaCollectionView
